import { AgentSessionManager } from '@Components/AgentChat';
import { EmptyState } from '@Components/EmptyState';
import { Page } from '@Components/Page';
import { PAGE_NAMES } from '@Components/Page/page-constants';
import { Agent, useAgentEndpoint } from '@src/utils/agent-endpoints';
import { useCompanyInfo } from '@src/utils/hooks/useCompanyInfo';

// Full-page version of the Activity Feed's Oracle drawer (ActivityFeedAgentDrawer); `company` pins
// the conversation to the URL's client.
export const OracleChat = () => {
  const { cid: company, name } = useCompanyInfo();
  const agentEndpoint = useAgentEndpoint(Agent.ORACLE);

  return (
    <Page title='Oracle' pageType={PAGE_NAMES.ORACLE_CHAT}>
      {/* Keyed by client so switching clients starts a fresh session. */}
      <AgentSessionManager
        key={company}
        agent={Agent.ORACLE}
        agentEndpoint={agentEndpoint}
        company={company}
        placeholder='Ask about this client...'
        emptyState={
          <EmptyState
            title={`Ask Oracle about ${name || company}`}
            subtitle='Answers are scoped to this client. Type a question below to start.'
          />
        }
        startFresh
      />
    </Page>
  );
};
